import { FormattedMessage } from 'react-intl';

import { Link, Stack, StackProps, Typography } from '@mui/material';

import { ROUTES } from '@arrived/common';
import { useFormatPercent } from '@arrived/hooks';

export interface TotalReturnSectionProps extends StackProps {
  isDirty?: boolean;
  totalReturnRate: number;
}

export const TotalReturnSection = ({ isDirty, sx, totalReturnRate, ...rest }: TotalReturnSectionProps) => {
  const formatPercent = useFormatPercent();

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      gap={1}
      py={3}
      sx={{ backgroundImage: ({ gradients }) => gradients.sea.horizontal, ...sx }}
      {...rest}
    >
      <Typography variant="body1" color="white">
        {isDirty ? (
          <FormattedMessage id="calculator-total-return-title-dirty" defaultMessage="Hypothetical One Year Return" />
        ) : (
          <FormattedMessage
            id="calculator-total-return-title-clean"
            defaultMessage="One Year Return Historical Average"
          />
        )}
      </Typography>
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Typography component="span" fontWeight="semibold" variant="h4" color="white">
          {formatPercent(totalReturnRate)}
        </Typography>
        <Typography component="span" color="white">
          {'/'}
        </Typography>
        <Typography component="span" color="white">
          <FormattedMessage id="year" defaultMessage="Year" />
        </Typography>
      </Stack>
      <Typography variant="body2" color="white" textAlign="center">
        <span style={{ opacity: isDirty ? 1 : 0, transition: 'opacity 250ms' }}>
          <FormattedMessage id="dirty-disclaimer-text" defaultMessage="Based on your selected performance numbers." />
          <br />
        </span>
        <FormattedMessage
          id="calculator-total-return-disclaimer"
          defaultMessage={`Past performance does not guarantee future returns.{br}
          Hypothetical returns are not inclusive of potential property disposition costs.{br}
          For more information, refer to the <link>Offering Circular</link>.`}
          values={{
            br: <br />,
            link: (parts: any) => (
              <Link fontSize="inherit" color="inherit" href={ROUTES.public.offeringCircular}>
                {parts}
              </Link>
            ),
          }}
        />
      </Typography>
    </Stack>
  );
};
